import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const XdrSearchResultsPanel = document.createElement('template');

XdrSearchResultsPanel.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
     ${/* TBD: gz-grid-view */ ''}
      <div class="content">
            <div class="grid">
                <gz-grid-view class="grid-view pl-2 pr-2" removeFilters hideFiltersToggle></gz-grid-view>
            </div>
      </div>
  </div>
`;
